import React from 'react'
import { t } from 'ttag'

import { Accordion } from 'components/shared/Accordion/Accordion'
import { AccordionContext } from 'components/shared/Accordion/context'
import HelpCardChevron from './HelpCardChevron'

const HelpSkillCategoryCardHeader = ({ category, skillCount }) => {
  const { handleToggle, isOpen } = React.useContext(AccordionContext)

  return (
    <button
      type="button"
      className="HelpTraitCard__header HelpSkillCategoryCard__header"
      onClick={handleToggle}
      aria-expanded={isOpen}
    >
      <span className="HelpTraitCard__heading">
        <span className="HelpTraitCard__title">{category}</span>
        <span className="HelpTraitCard__description">
          {skillCount === 1 ? t`${skillCount} skill` : t`${skillCount} skills`}
        </span>
      </span>
      <HelpCardChevron />
    </button>
  )
}

const HelpSkillCategoryCard = ({ category, skills }) => (
  <Accordion className="HelpTraitCard HelpSkillCategoryCard">
    <HelpSkillCategoryCardHeader
      category={category}
      skillCount={skills.length}
    />
    <Accordion.Panel className="HelpSkillCategoryCard__panel">
      <ul className="HelpSkillCategoryCard__list">
        {skills.map(skill => (
          <li key={skill.key}>{skill.label}</li>
        ))}
      </ul>
    </Accordion.Panel>
  </Accordion>
)

export default HelpSkillCategoryCard
